export const Emotes = {
  IDLE: 'asset://emote-idle.glb',
  WALK: 'asset://emote-walk.glb?s=1.5',
  RUN: 'asset://emote-run.glb?s=1.5',
  FLOAT: 'asset://emote-float.glb',
  FALL: 'asset://emote-fall.glb',
  FLIP: 'asset://emote-flip.glb?s=1.5',
  TALK: 'asset://emote-talk.glb',
}

export const emoteUrls = [Emotes.IDLE, Emotes.WALK, Emotes.RUN, Emotes.FLOAT, Emotes.FALL, Emotes.FLIP, Emotes.TALK]
